import React from "react"
import { HStack, Tooltip } from "@chakra-ui/react"
import { MotionBox } from "./index"
import { CoolDownStatus, Staking } from "container/staking"
import { formatTime } from "util/time"

enum LightType {
    Red,
    Green,
    Gray,
}

function Light({ type }: { type: LightType }) {
    switch (type) {
        case LightType.Green:
            return <GreenLight />
        case LightType.Red:
            return <RedLight />
        case LightType.Gray:
        default:
            return <GrayLight />
    }
}

export const PendingProgress = () => {
    const { cooldownStatus, withdrawTime, coolDownPeriod } = Staking.useContainer()
    const unreadyQuantity = coolDownPeriod !== 0 ? Math.ceil(withdrawTime.secondsUnit / (coolDownPeriod / 5)) : 0
    const isReady = cooldownStatus === CoolDownStatus.readyToWithdraw

    return (
        <Tooltip fontSize="xs" label={formatTime(withdrawTime.humanReadable)}>
            <HStack spacing="6px">
                {Array(5)
                    .fill(undefined)
                    .map((_, idx) => {
                        const lightType = isReady
                            ? LightType.Green
                            : idx < 5 - unreadyQuantity
                            ? LightType.Gray
                            : LightType.Red
                        return <Light type={lightType} key={idx} />
                    })}
            </HStack>
        </Tooltip>
    )
}

function GrayLight() {
    return <MotionBox borderRadius="10px" width="4px" height="10px" bgColor="#D1D1D1" />
}

function GreenLight() {
    return <MotionBox borderRadius="10px" width="4px" height="10px" bgColor="green.500" />
}

function RedLight() {
    return (
        <MotionBox
            borderRadius="10px"
            width="4px"
            height="10px"
            bgColor="#FD605B"
            animate={{ opacity: 0.3 }}
            transition={{
                duration: 2,
                repeat: Infinity,
                repeatType: "reverse",
                delay: 0.5,
            }}
        />
    )
}
